import './sms-list.less';

import React from 'react';
import {inject, observer} from 'mobx-react';
import {Loading} from '../../../common/loading';
import {SmsStatusName} from '../../../../models/sms';
import {PhoneNumber} from '../../../common/phone-number';
import {Link, withRouter} from 'react-router-dom';
import {Button} from 'antd';
import {formatContactType} from '../../../../utils/format-contact-type';
import {formatDate} from '../../../../utils/format-date';
import {PageFooterNav} from '../common/page-footer-nav';
import {toJS} from 'mobx';

@withRouter
@inject('smsListStore')
@observer
export class SmsList extends React.Component {

  componentWillMount() {
    const query = new URLSearchParams(this.props.location.search);

    let page = 1, pageSize = 50;

    if (query.get('page')) {
      page = parseInt(query.get('page'));
    }
    if (query.get('pageSize')) {
      pageSize = parseInt(query.get('pageSize'));
    }

    this.props.smsListStore.resetFilters();
    this.props.smsListStore.changePageAndLoad(page, pageSize);
  }

  render() {
    const { isLoading, items, total, filters, page, pageSize  } = this.props.smsListStore;

    return (
      <div className="sms-list-page">
        <div className="sms-list-header">
          <h1>Список сообщений</h1>
          <Link to={'/crm/sms/send'}><Button type={'primary'} size={'large'}>Отправить смс</Button></Link>
        </div>

        <div className="sms-list">
          {isLoading && <Loading />}
          {!isLoading && (
            <React.Fragment>
              <div className="sms-item sms-item-header">
                <div className="sms--date">Дата отправки</div>
                <div className="sms--status">Статус</div>
                <div className="sms--contact-type">Тип клиента</div>
                <div className="sms--contact-name">Имя клиента</div>
                <div className="sms--phone">Телефон</div>
                <div className="sms--message">Сообщение</div>
                <div className="sms--cost">Стоимость</div>
              </div>

              {items.map(sms => (
                <div className="sms-item" key={sms.smsId}>
                  <div className="sms--date">{formatDate(sms.createdAt * 1000)}</div>
                  <div className="sms--status">{SmsStatusName[sms.status]}</div>
                  <div className="sms--contact-type">{formatContactType(sms.contact.type)}</div>
                  <div className="sms--contact-name">{sms.contact.name}</div>
                  <div className="sms--phone"><PhoneNumber phone={sms.phone}/></div>
                  <div className="sms--message">{sms.text}</div>
                  <div className="sms--cost">{this.formatCost(sms.cost)}</div>
                </div>
              ))}
            </React.Fragment>
          )}

          <PageFooterNav
            page={page}
            pageSize={pageSize}
            total={total}
            onChangePagination={this.onChangePagination}

            filters={toJS(filters)}
            patchFilters={data => this.props.smsListStore.patchFilters(data)}
            applyFilters={() => this.props.smsListStore.load()}
          />

        </div>
      </div>
    );
  }

  formatCost(cost) {
    return parseInt(cost).toFixed(2) + ' руб.'
  }

  onChangePagination = (page, pageSize) => {
    this.props.smsListStore.changePageAndLoad(page, pageSize);
    this.props.history.push(`?page=${page}&pageSize=${pageSize}`);
  };
}



// WEBPACK FOOTER //
// ./src/components/pages/crm/sms/sms-list.js